module.exports = __webpack_public_path__ + "img/13-half-lg.022fe1c2.jpg";